var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"instruction":"Finalising Nedbank Direct payment..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }